import { useEffect, useRef } from 'react';
import './techdetails.css';
import CardTemplate from '../CardTemplate/CardTemplate';
import Tabs from '../Tabs/Tabs';
import { ITabsData } from '../../types/type';
import TechInfoCard from '../TechInfoCard/TechInfoCard';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { fetchSelectedTechData } from '../../store/techdata/techdataSlice';
import { useAppDispatch } from '../../store/hooks';
import { fullName } from '../../utils/utils';

function TechDetails({ id, onUserClick }: { id: string; onUserClick: (id: string) => void }) {
  const dispatch = useAppDispatch();
  const selectedTechList = useSelector((state: RootState) => state.techdata.selectedTechLists);

  useEffect(() => {
    dispatch(fetchSelectedTechData({ id }));
  }, []);

  const componentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (componentRef.current && !componentRef.current.contains(event.target as Node)) {
        onUserClick('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const tabs: ITabsData[] = [
    {
      id: 1,
      title: 'Технические данные',
      component: <TechInfoCard selectedTechList={selectedTechList} />,
      style: '',
    },
  ];

  return (
    <div ref={componentRef}>
      <CardTemplate onUserClick={onUserClick}>
        <Tabs tabsData={tabs} fio={fullName(selectedTechList?.profile)} />
      </CardTemplate>
    </div>
  );
}

export default TechDetails;
